import { RootState } from 'store';
import { IRolesResponse } from 'types/roles-and-rights.interface';

export const getRolesSelector = (store: RootState): IRolesResponse | null => store.roles.roleList || null;
export const isRolesFirstCallSelector = (store: RootState): boolean => store.roles.isLoading;
export const getRolesIsLoadingSelector = (store: RootState): boolean => store.roles.isLoading;
